export default (inputs, context) => {
    const val = inputs.if
		? inputs.then
		: inputs.else;
	return ({
		type: val.type,
		value: val.value,
	});
};